
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/project/[projectId]/testSuite/[testSuiteId]",
      function () {
        return require("private-next-pages/project/[projectId]/testSuite/[testSuiteId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/project/[projectId]/testSuite/[testSuiteId]"])
      });
    }
  